import React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { Popup } from 'components/UI/Popup';

import css from './limitTimeOfferPopupMeplusyouTheme.module.sass';

interface Props {
  onSubmit?: () => void;
  onClose?: () => void;
}

export const LimitTimeOfferPopupMeplusyouTheme: React.FC<Props> = ({
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation(['common', 'app']);

  return (
    <Popup isFullScreen isIndented={false} onClose={onClose}>
      <div className={css.root}>
        <div className={css.container}>
          <section className={css.content}>
            <span className={css.discount}>
              {t('app:limitedTimeOffer.discount', {
                discount: 75,
              })}
            </span>
            <h1 className={css.title}>
              {t('app:limitedTimeOffer.specialOffer')}
            </h1>
            <p className={css.desc}>
              {t('app:limitedTimeOffer.getDiscount', {
                discount: 75,
              })}
            </p>
          </section>

          <section className={css.actions}>
            <BaseButton type={ButtonTypes.Contrast} onClick={onSubmit}>
              {t('app:limitedTimeOffer.subscribeNow')}
            </BaseButton>
            <BaseButton
              type={ButtonTypes.Transparent}
              className={css.closeBtn}
              onClick={onClose}
            >
              {t('common:skip')}
            </BaseButton>
          </section>
        </div>
      </div>
    </Popup>
  );
};
